import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const ManualBanco = ({ open, handleClose }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const textContent = `
  ** 1 - Funcionamento do componente de conciliação bancária e descrição dos campos **

  **1.1 Objetivo:**  
 
  O sistema é projetado para facilitar o processo de conciliação bancária. Ele permite carregar arquivos contábeis e extratos bancários, processar esses arquivos e visualizar os resultados da conciliação de forma clara e organizada.
  O sistema compara se os campos débito, crédito e histórico existem no arquivo disponibilizado pelo sistema e no extrato bancário e realiza a conciliação dos mesmos.

  1. Carregamento de Arquivos:
  
  Arquivo do Sistema: Este campo permite ao usuário selecionar o arquivo contábil gerado pelo sistema da empresa. Ele pode escolher o sistema de origem do arquivo ou a opção Padrão se utilizar o layout padrão do sistema
  
  Arquivo do Banco: Aqui, o usuário pode selecionar o extrato bancário fornecido pelo banco. Também é possível especificar o banco correspondente ou a opção Padrão se utilizar o layout padrão do sistema
  
  2. Processamento:
  
  Após carregar os arquivos e selecionar as opções adequadas, o usuário pode clicar no botão "Processar" para iniciar o processamento dos arquivos. Durante esse processo, uma barra de progresso pode ser exibida para indicar o andamento da operação.
  
  3. Resultados da Conciliação:
  
  Após o processamento, os resultados da conciliação são apresentados em três seções principais:
  
  Razão Contábil: Mostra as transações registradas no sistema contábil da empresa, juntamente com informações adicionais, como data, débitos, créditos e status de conciliação.
  
  Extrato Bancário: Exibe as transações registradas no extrato bancário fornecido pelo banco, incluindo data, débitos, créditos e status de conciliação.
  
  Resumo Diário: Apresenta um resumo das transações diárias, incluindo débitos, créditos e saldo diário, bem como a diferença entre o razão contábil e o extrato bancário.
  
  `;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Manual de conciliação bancária
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          placeholder="Buscar..."
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Typography component="pre" variant="body1" style={{ whiteSpace: 'pre-wrap', marginTop: '16px', fontSize: '14px', lineHeight: '1.6' }}>
          {textContent.split('\n').map((line, index) => (
            <span
              key={index}
              style={{
                backgroundColor: line.toLowerCase().includes(searchTerm.toLowerCase()) && searchTerm ? 'yellow' : 'inherit',
              }}
            >
              {line}
              <br />
            </span>
          ))}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ManualBanco;
